import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Modal } from 'antd';

import { EDIT, JOBS } from 'constants/path';

import styles from './RetryPaymentSuccessModal.module.scss';

interface UpdatePaymentSuccessModalProps {
  jobId: string | null;
  open: boolean;
  onCancel: () => void;
  onActivate: () => void;
}

export const RetryPaymentSuccessModal: React.FC<
  UpdatePaymentSuccessModalProps
> = ({ jobId, open, onCancel, onActivate }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleKeepEditing = () => {
    if (!jobId) {
      return;
    }

    onCancel();
    navigate(`${JOBS}/${jobId}${EDIT}`);
  };

  return (
    <Modal
      title={t('modal.retryPaymentSuccess.title')}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={552}
      destroyOnHidden
    >
      <div className={styles.wrap}>
        <h2 className={styles.description}>
          {t('modal.retryPaymentSuccess.description')}
        </h2>
        <div className={styles.buttonsWrapper}>
          <Button type="link" onClick={onCancel}>
            {t('common.skip')}
          </Button>
          <Button type="primary" onClick={onActivate}>
            {t('common.activateNow')}
          </Button>
          <Button type="primary" onClick={handleKeepEditing}>
            {t('common.keepEditing')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
